import i18n from "../../../i18n";
import Term from "../../term/Term";
import { fetchGroupLanguageCode } from "../../groups/groupAPI";
import { errorSubscriberOnly } from "../../common/OnevocaServerError";
import SentenceHistory from "../model/SentenceHistory";
import { fetchMoreSentence } from "./sentenceAPI";

type TermListUpdater = (updater: (prevTerms: Term[]) => Term[]) => void;

function updateTerm(
  setTerms: TermListUpdater,
  termId: string,
  changes: Partial<Term>
) {
  setTerms((prevTerms) => {
    const index = prevTerms.findIndex((t) => t.id === termId);
    if (index === -1) return prevTerms;

    const updated = [...prevTerms];
    updated[index] = { ...updated[index], ...changes };
    return updated;
  });
}

/**
 * 다른 예문 보기. 구독 여부는 서버가 판별하며, 비구독자에게는 에러 10000이 돌아온다.
 * 화면마다 termList 상태 형태가 같아 setTerms 만 넘겨받아 공유한다.
 * history 는 화면이 들고 있는 예문 기록으로, 이미 받은 예문을 서버에 함께 보낸다.
 */
export async function generateMoreSentence(
  term: Term,
  setTerms: TermListUpdater,
  history: SentenceHistory
) {
  updateTerm(setTerms, term.id, { isMoreSentenceLoading: true });

  try {
    const languageCode =
      term.group.length !== 0 ? await fetchGroupLanguageCode(term.group) : "";
    const sentence = await fetchMoreSentence(term.term, languageCode, history);

    updateTerm(setTerms, term.id, {
      sentence,
      isMoreSentenceLoading: false,
    });
  } catch (error) {
    updateTerm(setTerms, term.id, { isMoreSentenceLoading: false });

    if (error instanceof Error && error.name === errorSubscriberOnly) {
      alert(i18n.t("MoreExamplesSubscriberOnlyMessage"));
    } else if (error instanceof Error) {
      alert(error.message);
    } else {
      alert(error);
    }
  }
}
